import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Button from "@mui/material/Button";
import type { SxProps } from "@mui/material/styles";

type FilterDropDownButtonProps = {
  open?: null | Boolean;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  sx?: SxProps;
  /** Shown but not usable: a lock replaces the arrow, so the button keeps its width. */
  disabled?: boolean;
};

export default function FilterDropDownButton({
  label,
  open,
  sx,
  handleClick,
  disabled = false
}: FilterDropDownButtonProps) {
  return (
    <Button
      id="filter-dropdown-button"
      aria-controls={open ? "filter-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      variant="contained"
      disableElevation
      onClick={handleClick}
      disabled={disabled}
      endIcon={disabled ? <LockOutlinedIcon /> : <KeyboardArrowDownIcon />}
      sx={{
        "&.MuiButton-containedSizeMedium": {
          padding: "5px 15px "
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
}
